module.exports = __webpack_public_path__ + "static/img/EG.e49ec99e.svg";